import React from "react";
import { useEffect, useState } from "react";
import BundleWrapper from "./BundleWrapper";
import BundleVariantTile from "./BundleVariantTile";
import styled from "styled-components";
import { colors, font } from "../../lib/sharedStyles";
import translate from "translate";

const StyledCarousel = styled.div`
  margin-left: 72px;
  margin-top: 200px;
  @media only screen and (max-width: 600px) {
    margin-left: 16px;
    margin-top: 0px;
  }
  `


const BundleCarousel = () => {
  const [translatedHeading, setTranslatedHeading] = useState<string>('');

  useEffect(() => {
    const dataElement = document.getElementById('bundle-carousel');
    const language = dataElement?.getAttribute('data-language') || 'en';
    const locale = dataElement?.getAttribute('data-locale') || 'en-US';
    const translateText = async () => {
      const translation = await translate("What's included", { to: language });
      setTranslatedHeading(translation);
    };

    translateText();
  }
  , []);
  const variantIds: string[] = JSON.parse(
    document.getElementById("bundle-variants")!.textContent || "[]"
  );
  return (
    <StyledCarousel>

    <BundleWrapper
      heading={translatedHeading}
      variantIds={variantIds}
      Component={BundleVariantTile}/>
      
    </StyledCarousel>
  );
};

export default BundleCarousel;
